const merge = arr => arr.reduce((obj, val) => ({ ...obj, ...val }), {})

export default merge



// WEBPACK FOOTER //
// ./src/utilities/merge.js